import React, { useState, useEffect, useRef } from 'react';
import WithFlow from 'conversie-flow-bundle/assets/js/components/flow/WithFlow';
import VehicleConfiguratorHeader from "../../VehicleConfigurator/components/VehicleConfiguratorHeader";

/* Images */

/* Utilities */
import { trans } from 'js/utilities';

export default function ConversionFlowOverlay({
    open,
    flowUrl,
    handleClose,
    webspace,
    locale,
    overlayBody,
    ...flowProps
}) {

    const [stateOpen, setStateOpen] = useState(open ? 'open' : 'closed');
    const overlayRef = useRef(null);

    useEffect(() => {
        if (open !== (stateOpen === 'open' || stateOpen === 'opening')) {
            setStateOpen(open ? 'opening' : 'closing');

            if (open) {
                document.body.classList.add('overflow-hidden');
            } else {
                document.body.classList.remove('overflow-hidden');
            }

            const timeoutId = setTimeout(() => {
                setStateOpen(open ? 'open' : 'closed');
            }, 300);

            return () => clearTimeout(timeoutId);
        }
    }, [open]);

    useEffect(() => {
        if (!open) return;

        overlayRef.current?.focus();

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') handleClose();
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [open, handleClose]);

    if (stateOpen === 'closed') return null;

    return (
        <div ref={overlayRef} className={`flow-overlay ${stateOpen}`} tabIndex={-1}>
            {flowUrl && !flowProps?.flow ? (
                <WithFlow
                    flowUrl={flowUrl}
                    flow={null}
                    translate={trans}
                >
                    {(flowProps) => {
                        const {flow: newFlow, setStep: newSetStep} = flowProps;

                        return (
                            <>
                                {newFlow?.steps && newFlow?.steps.length > 0 && (
                                    <VehicleConfiguratorHeader
                                        webspaceKey={webspace}
                                        locale={locale}
                                        inConversionFlow={true}
                                        handleClose={handleClose}
                                    />
                                )}
                                <ConversionFlowOverlayContent
                                    {...flowProps}
                                    flow={newFlow}
                                    setStep={newSetStep}
                                    overlayBody={overlayBody}
                                />
                            </>
                        );
                    }}
                </WithFlow>
            ) : (
                <ConversionFlowOverlayContent
                    {...flowProps}
                    overlayBody={overlayBody}
                />
            )}
        </div>
    );
}

function ConversionFlowOverlayContent({ overlayBody, ...flowProps }) {
    return (
        <div className="flow-overlay__body p-lg-12">
            {overlayBody({ ...flowProps })}
        </div>
    );
}

